<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
@if (internalTiles.length > 0) {
  <div class="ys-carousel">
    <div #carouselContent class="ys-carousel-content" 
      [style.width]="((internalTiles.length+1)*100).toString()+'%'"
      [style.transform]="transformStyle()"
      [style.transition]="transitionStyle()"
      (click)="handleClick()" 
      (touchstart)="swipe($event, 'start')"
      (touchend)="swipe($event, 'end')">
      @for (tile of internalTiles; track tile; let i = $index) {
        <ys-carousel-image 
          [src]="tile.src" 
          [alt]="tile.alt" 
          [imgStyle]="tile.style" 
          [title]="tile.alt"
          [imgClass]="tile.class" 
          [sizes]="tile.sizes" 
          [loading]="tile.loading" 
          [crossOrigin]="tile.crossOrigin"
          [priority]="tile.priority" 
          [repo]="repo()" />
      }
      <!-- extra tile at the end -->
      @defer(on viewport;) {
        <ys-carousel-image 
          [src]="internalTiles[0].src" 
          [alt]="internalTiles[0].alt" 
          [imgStyle]="internalTiles[0].style" 
          [title]="internalTiles[0].alt"
          [imgClass]="internalTiles[0].class" 
          [sizes]="internalTiles[0].sizes" 
          [loading]="internalTiles[0].loading"
          [crossOrigin]="internalTiles[0].crossOrigin" 
          [priority]="internalTiles[0].priority" 
          [repo]="repo()" />
      } @placeholder(minimum 250ms) {
        <div></div>
      }
  </div>
  @if (internalConfig.progressIndicator === true) {
    <div class="ys-carousel-progress-indicator">
      <mat-progress-bar mode="determinate" [value]="100*((index()+1)/tiles().length)"
      color="primary"></mat-progress-bar>
    </div>
  }
  @if (tiles().length > 1 && index() > 0 && index() < tiles().length  && internalConfig.controls === true) {
    <div
      class="ys-carousel-button-left">
      <button type="button" mat-icon-button (click)="left()" class="ys-carousel-control-button"
        aria-label="Zurück"><mat-icon>chevron_left</mat-icon></button>
      </div>
    }
    @if (tiles().length > 1 && tiles().length > (index()+1) && internalConfig.controls === true) {
      <div
        class="ys-carousel-button-right">
        <button type="button" mat-icon-button (click)="right()" class="ys-carousel-control-button"
          aria-label="Vorwärts"><mat-icon>chevron_right</mat-icon></button>
        </div>
      }
      @if (tiles().length > 1 && state() === 'PAUSED' && internalConfig.playButton === true) {
        <div
          class="ys-carousel-button-play">
          <button type="button" mat-icon-button (click)="play()" class="ys-carousel-control-button"
            aria-label="Autoplay fortsetzen"><mat-icon>play_circle_filled</mat-icon></button>
          </div>
        }
        @if (tiles().length > 1 && internalConfig.pagination === true) {
          <div class="ys-carousel-pagination">
            <ul class="ys-carousel-pagination-list">
              @for (tile of tiles(); track tile; let idx = $index) {
                <li [class.active]="idx === index()" (click)="moveTo(idx)">
                </li>
              }
            </ul>
          </div>
        }
      </div>
    }